module.exports = __webpack_public_path__ + "static/img/14000582.3ff86b93.png";